import { X } from '@phosphor-icons/react';
import clsx from 'clsx';
import React from 'react';
import { createPortal } from 'react-dom';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    width?: string;
    children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
    isOpen, onClose, title, width = 'max-w-md', children 
}) => {
    if (!isOpen) return null;
    return createPortal(
        <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/20 backdrop-blur-sm p-4" onClick={onClose}>
            <div className={clsx("bg-white w-full rounded-2xl shadow-xl p-6", width)} onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-bold text-gray-900">{title}</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
                </div>
                {children}
            </div>
        </div>,
        document.body
    );
};

export default Modal;
